var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.m),expression:"m"}],staticClass:"calculator__input",class:_vm.classes,attrs:{"id":_vm.id,"aria-label":_vm.label,"type":"text"},domProps:{"value":(_vm.m)},on:{"input":function($event){if($event.target.composing)return;_vm.m=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }